import Apptimize from '@apptimize/apptimize-web-sdk'

export const getBoolFromApptimize = (
  flag: string,
  defaultValue: boolean = false
) => {
  return Apptimize.getBool(flag, defaultValue)
}
